import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonTitle } from 'web-ui-components/lib/atoms/buttons';
import { Icon } from 'web-ui-components/lib/atoms/iconography';

export const AddPayeeButton = ({ onClick, title }) => (
	<Button display="secondary" onClick={onClick} data-test-id="add-new-payee-cta-sme">
		<Icon iconType="PlusOutlineLarge" direction="left" />
		<ButtonTitle>{title}</ButtonTitle>
	</Button>
);

AddPayeeButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
};
export default AddPayeeButton;
